import React, { useEffect, useState } from 'react'
import MainLoader from './components/MainLoader'
import { Button, Card, CardContent, Dialog, DialogContent, Grid, List, ListItem, ListItemButton, ListItemText, MenuItem, Select, TextField, Typography, IconButton } from '@mui/material'
import Sidebar from './components/Sidebar'
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { useNavigate } from 'react-router'
import i18next from 'i18next';
import noDataFound from "../src/assests/images/no-report-ic.svg";
import { postApi } from './api/services';
import { serviceDown, trackEvent } from './utils/UtilityFunctions';
import moment from 'moment';
import SyncIcon from '@mui/icons-material/Sync';
import imgurl from './assests/images/imgurl';
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import { useLocation } from 'react-router-dom';
import AttachmentIcon from '@mui/icons-material/Attachment';
import CameraAltIcon from '@mui/icons-material/CameraAlt';

const PrescriptionList = () => {

  const navigate = useNavigate()
  const location = useLocation()
  const [isLoading, setIsLoading] = useState(false)
  const [dataList, setDataList] = useState([])
  const [validationData, setValidationData] = useState({})
  const [userDetails, setUserDetails] = useState({})
  const [isRotating, setIsRotating] = useState(false);
  const [formulation, setFormulation] = useState('')
  const [remarks, setRemarks] = useState('')
  const [formulations, setFormulations] = useState([])
  const [openImg, setOpenImg] = useState(false)
  const [imgUrl, setImageUrl] = useState('')
  const [image, setImage] = useState(null);

  const formulationsMale = [
    { 
      name: "Dutasteride: 1mg/ml(60mg)", 
      value: "Dutasteride: 1mg/ml(60mg)", 
      bottle: "One - 60ml Bottle - Dropper Liquid",
      detail: "Dutasteride: 1mg/ml(60mg total)",
      identifier: 'bottle'
    },
    { 
      name: "Dutasteride: 2mg/ml (120mg)", 
      value: "Dutasteride: 2mg/ml (120mg)", 
      bottle: "Two - 60ml Bottle - Dropper Liquid",
      detail: "Dutasteride: 2mg/ml (120mg total)",
      identifier: 'bottle'
    },
    { 
      name: "Dutasteride: 5mg/ml (300mg)", 
      value: "Dutasteride: 5mg/ml (300mg)", 
      bottle: "Five - 60ml Bottle - Dropper Liquid",
      detail: "Dutasteride: 5mg/ml (300mg total)",
      identifier: 'bottle'
    },
    { 
      name: "(foam)Dutasteride: 1mg/ml(60mg)", 
      value: "(foam)Dutasteride: 1mg/ml(60mg)",
      bottle: "One Foam - 60ml",
      detail: "Dutasteride: 1mg/ml(60mg total)",
      identifier: 'foam'
    },
    { 
      name: "(foam)Dutasteride: 2mg/ml (120mg)", 
      value: "(foam)Dutasteride: 2mg/ml (120mg)", 
      bottle: "Two Foam - 60ml",
      detail: "Dutasteride: 2mg/ml (120mg total)",
      identifier: 'foam'
    },
    { 
      name: "(foam)Dutasteride: 5mg/ml (300mg)", 
      value: "(foam)Dutasteride: 5mg/ml (300mg)",
      bottle: "Five Foam - 60ml",
      detail: "Dutasteride: 5mg/ml (300mg total)",
      identifier: 'foam'
    }
  ]

  const formulationsFemale = [
    { 
      name: "Dutasteride: 1mg/ml(60mg)", 
      value: "Dutasteride: 1mg/ml(60mg)", 
      bottle: "One - 60ml Bottle - Dropper Liquid",
      detail: "Dutasteride: 1mg/ml(60mg total)",
      identifier: 'bottle'
    },
    { 
      name: "Dutasteride: 5mg/ml (300mg)", 
      value: "Dutasteride: 5mg/ml (300mg)", 
      bottle: "Five - 60ml Bottle - Dropper Liquid",
      detail: "Dutasteride: 5mg/ml (300mg total)",
      identifier: 'bottle'
    }
  ]

  const bottlePrescriptionDetails = [
    'Follicle Delivery System',
    'GHK-Cu (Copper Tripeptide-1)',
    'Acetyl Tetrapeptide-3',
    'Excipients Phenoxyethanol and Caprylyl Glycol',
    'Sterile water according to required final concentrations'
  ]

  const foamPrescriptionDetails = [
    'Follicle Delivery System',
    'GHK-Cu (Copper Tripeptide-1)',
    'Acetyl Tetrapeptide-3',
    'Dimethyl Sulfoxide (DMSO)',
    'Acrylates/C10-30 Alkyl Acrylate Crosspolymer (foam)',
    'Excipients Phenoxyethanol and Caprylyl Glycol',
    'Sterile water according to required final concentrations'
  ]

  useEffect(() => {
    // getPrescription()
    // validationReview()
    getAiAnalysis()
    getUserDetails()
  }, [])

  const getPrescription = async () => {
    try {
      setIsLoading(true)
      let params = {
        // user_id: 141
        user_id: localStorage.getItem('user_id')
      }
      console.log("get_user_prescriptions params", params);
      const res = await postApi('get_user_prescriptions', params)
      if(res){
        console.log("get_user_prescriptions res", res);
        await trackEvent('prescription_list_viewed', 'success', '', localStorage.getItem('phno'))
        setDataList(res?.prescriptions)
        setIsLoading(false)
      }
    } catch (err) {
      console.log("err", err);
      await trackEvent('prescription_list_viewed', 'fail', err, localStorage.getItem('phno'))
      setIsLoading(false)
      serviceDown(navigate, '/homepage')
    }
  }

  const validationReview = async () => {
    setIsLoading(true)
    let analysisId = location?.state?.user_obj?.reports?.[0]?.analysis_id
    let params = {
      validation_level: 1
    }
    console.log("validate_prescription params", params);
    try {
      let res = await postApi(`api/hair-analysis/${analysisId}/validation-review`, params)
      setValidationData(res)
      console.log("validate_prescription res", res);
      setIsLoading(false)
    } catch (err) {
      console.log("err", err);
      setIsLoading(false)
      serviceDown(navigate, '/homepage')
    }
  }

  const getAiAnalysis = async () => {
    setIsLoading(true)
    let params = {
      analysis_id: location?.state?.user_obj?.reports?.[0]?.analysis_id
    }
    console.log("get_ai_hair_analysis_report params", params);
    try {
      let res = await postApi('get_ai_hair_analysis_report', params)
      console.log("get_ai_hair_analysis_report res", res); 
      setIsLoading(false)
      if(res?.error) {
        serviceDown(navigate, '/clients')
      } else {
        setValidationData(res)
      }
    } catch (err) {
      console.log("err", err); 
      setIsLoading(false)
      serviceDown(navigate, '/clients') 
    }
  }

  const getUserDetails = async () => {
    setIsLoading(true)
    let params = {
      user_id: location?.state?.user_obj?.user_id
    }
    console.log("get_user_details params", params);
    try {
      let res = await postApi('get_user_details', params)
      setUserDetails(res)
      console.log("get_user_details res", res);
      setIsLoading(false)
      setFormulations(res?.gender && res.gender.toUpperCase() === 'MALE' ? formulationsMale : formulationsFemale)
    } catch (err) {
      console.log("err", err);
      setIsLoading(false)
      serviceDown(navigate, '/homepage')
    }
  }

  const uploadPrescription = async () => {
    if(formulation.trim !== '' && remarks.trim() !== '' && image) {
      setIsLoading(true)
      let doctorDetails = JSON.parse(localStorage.getItem('doctorobj'))
      let params = {
        user_id: location?.state?.user_obj?.user_id,
        prescribed_by: doctorDetails?.full_name,
        doctor_id: doctorDetails?.doctor_id,
        user_medical_history_validation: true,
        prescription_validation: true,
        prescription_comment: remarks,
        prescribed_medicine: formulation,
        analysis_id: location?.state?.user_obj?.reports?.[0]?.analysis_id,
        prescription_id: '',
        is_prescription_invalid: false,
        file_type: image.data.includes('pdf') ? 'pdf' : 'image',
        prescription: image.data.split(',')[1]
      }
      console.log("upload_prescription_by_doctor params", params);
      try {
        let res = await postApi('upload_prescription_by_doctor', params)
        console.log("upload_prescription_by_doctor res", res);
        setIsLoading(false)
        if(res?.error) { 
          serviceDown(navigate, '/homepage')
        } else {
          // navigate('/userprescription', {state: {prescription: res?.prescription, prescription_status: 'VALID', prescribed_medicine: res?.prescribed_medicine, user_obj: location.state.user_obj}})
          swal({
            title: i18next.t("Order placed successfully"),
            icon: "success",
          }).then((val) => {
            if(val) {
              navigate('/orders')
            }
          })
        }
      } catch (err) {
        console.log("err", err);
        setIsLoading(false)
        serviceDown(navigate, '/homepage')
      }
    } else {
      swal({
        title: i18next.t("Please fill all the fields"),
        icon: "warning",
      })
    }
  }

  // const uploadPrescription = async () => {
  //   setIsLoading(true)
  //   let doctorDetails = JSON.parse(localStorage.getItem('doctorobj'))
  //   let params = {
  //     user_id: location?.state?.user_obj?.user_id,
  //     prescribed_by: doctorDetails?.full_name,
  //     doctor_id: doctorDetails?.doctor_id,
  //     analysis_id: location?.state?.user_obj?.reports?.[0]?.analysis_id,
  //     file_type: image.data.includes('pdf') ? 'pdf' : 'image',
  //     base64: image.data.split(',')[1]
  //   }
  //   console.log('upload_prescription params', params);
  //   setIsLoading(false)
  // }

  const openPrescription = (e, data) => {
    navigate('/userprescription', {state: {prescription: data}})
  }

  const handleExplore = (e) => {
    e.stopPropagation()
    let encrypted = encryptPhoneNum(localStorage.getItem('phno'))
    let url = `https://shop.alopexia.com/products/alopexia-hair-restoration-medicine?phone=${encrypted}`;
    window.open(url, "_self");
  }

  const encryptPhoneNum = (phone) => {
    return btoa(encodeURIComponent(phone))
  }

  const handleRotate = () => {
    setIsRotating(true);  
    getPrescription()
  };

  const renderPrescriptionDetails = () => {
    let bottleVal = formulations.find(o => o.value === formulation)?.bottle;
    let dutastrideDetail = formulations.find(o => o.value === formulation)?.detail;
    let identifier = formulations.find(o => o.value === formulation)?.identifier;
    return (
      <Grid container spacing={0} className='d-flex justify-content-start align-items-start mb-20px'>
        <Grid item xs={12} className='d-flex justify-content-start align-items-start flex-direction-column'>
          <h3 className='mb-5px'>{i18next.t('Prescription Details:')}</h3>
          <p className='mb-0 text-left'>{i18next.t(`Compounded Hair Treatment ${bottleVal} `)}</p>
            <List className='presdetlist mb-5px' sx={{ listStyleType: 'disc', pl: 3, '& .MuiListItem-root': { display: 'list-item' } }}>
              <ListItem>
                <ListItemText>
                  {dutastrideDetail}
                </ListItemText>
              </ListItem>
              {
                identifier === 'bottle' ? 
                  bottlePrescriptionDetails.map((item, index) => (
                    <ListItem key={index}>
                      <ListItemText>
                        {item}
                      </ListItemText>
                    </ListItem>
                  ))
                    : 
                  foamPrescriptionDetails.map((item, index) => (
                    <ListItem key={index}>
                      <ListItemText>
                        {item}
                      </ListItemText>
                    </ListItem>
                  ))
              }
            </List>
          <p className='mb-0 text-left'>{i18next.t('Apply it once daily on a clean and dry scalp.')}</p>
        </Grid>
      </Grid>  
    )
  }

  const openImage = () => {
    return(
      <Dialog
        open={openImg}
        onClose={() => setOpenImg(!openImg)}
        className='openImageDialog commonDialogBox'
      >
        <DialogContent>
          <Grid container spacing={0} className='d-flex justify-content-center align-items-center flex-direction-column'>
            <div className='d-flex justify-content-end align-items-end w-100 mb-10px cursor-pointer'>
              <CloseIcon onClick={() => setOpenImg(false)}/>
            </div>
            <img 
              src={`data:image/jpeg;base64,${imgUrl}`}
            />
          </Grid>
        </DialogContent>
      </Dialog>
    )
  }

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onloadend = () => {
      if (reader.result) {
        setImage({
          name: file.name,
          type: file.type,
          data: reader.result, // Base64 or Data URL
        });
      } else {
        console.error("FileReader failed to load the file.");
      }
    };

    reader.onerror = (err) => {
      console.error("FileReader error: ", err);
    };

    // Read differently depending on file type
    if (file.type.startsWith("image/") || file.type === "application/pdf") {
      reader.readAsDataURL(file); // Works for both images & PDFs
    } else {
      console.error("Unsupported file type:", file.type);
    }
  };

  const handleRemoveImage = () => {
    setImage(null);
  };

  return (
    <>
      {isLoading && <MainLoader/>}
      <div className="photo-container main-section-container prescription-page">
        <Grid
          container
          spacing={0}
          className="d-flex justify-content-start align-items-center header"
        >
          <Grid item xs={1} className="">
            <div className="d-flex justify-content-start align-items-center">
              <span
                className="backButtonDiv"
                onClick={() => navigate(-1)}
              >
                <ArrowBackOutlinedIcon className="arrowBackBtn"></ArrowBackOutlinedIcon>
              </span>
            </div>
          </Grid>
          <Grid
            item
            xs={10}
            className="d-flex justify-content-center align-items-center reportPageHead"
          >
            <Typography variant="h6" className="title ml-0px">
              {i18next.t("Prescriptions")}
            </Typography>
          </Grid>
          {/* <Grid item xs={1} onClick={handleRotate} className="cursor-pointer">
            <SyncIcon className={isRotating ? "rotate-once" : ""} />
          </Grid> */}
          <Grid item xs={1}>
            <Sidebar />
          </Grid>
        </Grid>
        {
          Object.keys(userDetails)?.length > 0 ? 
            <div className='prescription_main_holder'>
              <div className='clientinfocard maincard d-flex justify-content-start align-items-start flex-direction-column'>
                <h3 className='mb-20px'>{i18next.t('Patient Information')}</h3>
                <p><span className='p-main'>{i18next.t('Full Name: ')}</span>{`${userDetails?.first_name} ${userDetails?.last_name}`}</p>
                <p><span className='p-main'>{i18next.t('Year of Birth: ')}</span>{`${userDetails?.date_of_birth}`}</p>
                <p><span className='p-main'>{i18next.t('Gender: ')}</span>{`${userDetails?.gender}`}</p>
                {/* <p><span className='p-main'>{i18next.t('Contact Number: ')}</span>{`+${userDetails?.phone_number}`}</p> */}
              </div>
              <div className='healthinfocard maincard d-flex justify-content-start align-items-start flex-direction-column'>
                <h3 className='mb-10px'>{i18next.t('Current Medications')}</h3>
                <p className='mb-20px'>{userDetails?.medications['Yes'] ? userDetails?.medications['Yes'] : userDetails?.medications['No']}</p>
                <h3 className='mb-10px'>{i18next.t('Hair Loss Duration')}</h3>
                <p className='mb-20px'>{userDetails?.hair_loss_duration ? userDetails.hair_loss_duration : 'NA'}</p>
                <h3 className='mb-10px'>{i18next.t('Hair Loss Treatment')}</h3>
                <p className='mb-5px'>{userDetails?.hair_loss_treatment['Yes'] ? userDetails?.hair_loss_treatment['Yes'] : userDetails?.hair_loss_treatment['No']}</p>
              </div>
              <div className='reportinfocard maincard grey d-flex justify-content-center align-items-center flex-direction-column'>
                <div className='reportinfoheader d-flex justify-content-start align-items-start flex-direction-column mb-20px'>
                  <p><span className='p-main'>{i18next.t('Report ID: ')}</span>{`${validationData?.report?.report_id}`}</p>
                  <p><span className='p-main'>{i18next.t('Created at: ')}</span>{`${moment(validationData?.report?.analysis_time).format("LLL")}`}</p>
                </div>
                <Grid container spacing={0} className='reportinfoholder'>
                  <Grid item xs={12} className='d-flex justify-content-center align-items-center'>
                    <p className='validatedstagetxt'>{`Validated - Stage ${validationData?.report?.norwood_stage ? validationData.report.norwood_stage : 'NA'}`}</p>
                  </Grid>
                </Grid>
                <Grid container spacing={0} className='d-flex justify-content-start align-items-center mt-10px mb-10px'>
                  <Grid item xs={6} className='photocontainer d-flex justify-content-center align-items-center flex-direction-column'>
                    <p className='mb-0'>{i18next.t('Front')}</p>
                    <div className='photo-div cursor-pointer' onClick={() => {
                        setOpenImg(true)
                        setImageUrl(validationData?.user_images?.front)
                      }}
                    >
                      <img className='clickedphoto' src={validationData?.user_images?.front ? `data:image/jpeg;base64,${validationData.user_images.front}` : imgurl.frontImgPrev}/>
                    </div>
                  </Grid>
                  <Grid item xs={6} className='photocontainer d-flex justify-content-center align-items-center flex-direction-column'>
                    <p className='mb-0'>{i18next.t('Top')}</p>
                    <div className='photo-div cursor-pointer' onClick={() => {
                        setOpenImg(true)
                        setImageUrl(validationData?.user_images?.top)
                      }}
                    >
                      <img className='clickedphoto' src={validationData?.user_images?.top ? `data:image/jpeg;base64,${validationData.user_images.top}` : imgurl.frontImgPrev}/>
                    </div>
                  </Grid>
                </Grid>
                {
                  userDetails?.gender?.toUpperCase() === 'MALE' &&
                  <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
                    <Grid item xs={6} className='photocontainer d-flex justify-content-center align-items-center flex-direction-column'>
                      <p className='mb-0'>{i18next.t('Left')}</p>
                      <div className='photo-div cursor-pointer' onClick={() => {
                          setOpenImg(true)
                          setImageUrl(validationData?.user_images?.left)
                        }}
                      >
                        <img className='clickedphoto' src={validationData?.user_images?.left ? `data:image/jpeg;base64,${validationData.user_images.left}` : imgurl.frontImgPrev}/>
                      </div>
                    </Grid>
                    <Grid item xs={6} className='photocontainer d-flex justify-content-center align-items-center flex-direction-column'>
                      <p className='mb-0'>{i18next.t('Right')}</p>
                      <div className='photo-div cursor-pointer' onClick={() => {
                          setOpenImg(true)
                          setImageUrl(validationData?.user_images?.right)
                        }}
                      >
                        <img className='clickedphoto' src={validationData?.user_images?.right ? `data:image/jpeg;base64,${validationData.user_images.right}` : imgurl.frontImgPrev}/>
                      </div>
                    </Grid>
                  </Grid>
                }
                <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
                  {openImage()}
                </Grid>
                <div className='reportinfohairanalysis maincard d-flex justify-content-start align-items-start flex-direction-column mt-20px mb-20px'>
                  <h3 className='mb-10px'>{i18next.t('Hair Analysis')}</h3>
                  <p><span className='p-main'>{i18next.t('Hair Density: ')}</span>{`${validationData?.report?.hair_density ? validationData.report.hair_density : 'NA'}`}</p>
                  <p><span className='p-main'>{i18next.t('Hair Type: ')}</span>{`${validationData?.report?.hair_type ? validationData.report.hair_type : 'NA'}`}</p>
                </div>
              </div>
              <div className='formulationinfo d-flex justify-content-start align-items-start flex-direction-column'>
                <div className='inputsholder'>
                  <Grid container spacing={0} className='d-flex justify-content-start align-items-center mb-20px'>
                    <Grid item xs={12} className='d-flex justify-content-start align-items-start flex-direction-column'>
                      <p className='p-head'>{i18next.t('Choose Prescription')}</p>
                      <Select
                        className='genderSelect'
                        value={formulation}
                        onChange={(e) => setFormulation(e.target.value)}
                        displayEmpty
                      >
                        <MenuItem value="" disabled>
                          {i18next.t('Please select')}
                        </MenuItem>
                        {
                          formulations.map((o, index) => (
                            <MenuItem key={index} value={o?.value}>
                              {o?.name}
                            </MenuItem>
                          ))
                        }
                      </Select>
                    </Grid>
                  </Grid>
                  {formulation && renderPrescriptionDetails()}
                  <Grid container spacing={0} className='d-flex justify-content-start align-items-center mb-20px'>
                    <Grid item xs={12} className='d-flex justify-content-start align-items-start flex-direction-column'>
                      <p className='p-head'>{i18next.t('Remark')}</p>
                      <TextField
                        placeholder='Please enter your remark'
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                      />
                    </Grid>
                  </Grid>    
                </div>
                <div className='inputsholder'>
                  <Grid container spacing={0} className='d-flex justify-content-start align-items-center mb-20px'>
                    <Grid item xs={12} className='d-flex justify-content-start align-items-start flex-direction-column'>
                      <p className='p-head'>{i18next.t('Upload Prescription')}</p>
                      <>
                        {!image && (
                          <Button variant="contained" component="label" className="commonButton uploadImageBtn mt-5px">
                            {i18next.t("Upload File")}
                            <input
                              type="file"
                              hidden
                              accept="image/*,application/pdf"
                              onChange={handleFileChange}
                            />
                          </Button>
                        )}

                        {image && (
                          <Grid container spacing={0} className='d-flex justify-content-start align-items-start'>
                            <Grid item xs={7} className='d-flex justify-content-start align-items-start'>
                              {image.type.startsWith("image/") ? (
                                <img
                                  src={image.data}
                                  alt={image.name}
                                  className='prescriptionImg'
                                />
                              ) : image.type === "application/pdf" ? (                              
                                <div className='d-flex justify-content-start align-items-center mt-10px prescriptionPdf'>
                                  {image.name.slice(0, 20)}<span className='ml-15px mt-5px'><AttachmentIcon/></span>
                                  {/* <p className='prescriptionPdf'>{image.name}<span className='ml-10px mt-5px'><AttachmentIcon/></span></p> */}
                                </div>
                              ) : null}
                            </Grid>
                            <Grid item xs={5} className='d-flex justify-content-start align-items-start'>
                              <IconButton className='ml-10px mt-10px' color="error" onClick={handleRemoveImage}>
                                <DeleteIcon />
                              </IconButton>        
                            </Grid>
                          </Grid>
                        )}
                      </>
                    </Grid>
                  </Grid>   
                </div>
              </div>
              <Button className='commonButton presribeBtn mb-20px' onClick={() => uploadPrescription()}>
                {i18next.t("Place Order")}
              </Button>
            </div> 
              :
            <div className="nodata<pdiv">
              <div className="nodatafoundimg">
                <img src={noDataFound} />
              </div>
              <Typography className="">
                {i18next.t("No prescriptions available")}
              </Typography>
            </div>
        }
      </div>
    </>
  )
}

export default PrescriptionList